import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

const options = {
  theme: {
    options: {
      customProperties: true,
    },
    // dark: true,
    themes: {
      light: {
        primary: {
          base: '#277faf',
          lighten5: '#BEDBEB',
          lighten4: '#A3EBFF',
          lighten3: '#86CFFF',
          lighten2: '#69B4E7',
          lighten1: '#2F80ED',
          darken1: '#006694',
          darken2: '#16558F',
          darken3: '#003761',
          darken4: '#002249',
        },
        secondary: {
          base: '#9e9e9e',
          lighten5: '#fafafa',
          lighten4: '#f3f3f3',
          lighten3: '#eeeeee',
          lighten2: '#ebeff2',
          lighten1: '#bdbdbd',
          darken1: '#757575',
          darken2: '#616161',
          darken3: '#424242',
          darken4: '#2c2c2c',
        },
        accent: colors.deepPurple.accent3,
        info: colors.teal.lighten1,
        warning: {
          base: '#F2994A',
          lighten1: '#F2C94C',
        },
        error: '#EB5757',
        success: {
          base: '#219653',
          lighten5: '#a5eeb3'
        },
      },
      dark: {
        primary: '#333333',
      },
    },
  },
}

export default new Vuetify(options)
